/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type SharedContactDealerWrapper_user$ref = any;
export type PdpRespHeroCarouselRequestMoreImages_user$ref = any;
export type PdpRespHeroCarouselRequestMoreImages_user = {
    readonly serviceId: string | null;
    readonly " $fragmentRefs": SharedContactDealerWrapper_user$ref;
    readonly " $refType": PdpRespHeroCarouselRequestMoreImages_user$ref;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespHeroCarouselRequestMoreImages_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "serviceId",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SharedContactDealerWrapper_user",
      "args": null
    }
  ]
};
(node as any).hash = '1312d899977bc0e275bac12dd2af63cc';
export default node;
